import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Home extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path d="M14.2,16H0.8L0,15.2V5.7L0.3,5L7,0H8l6.7,5L15,5.7v9.6L14.2,16z M1.6,14.4h11.9V6L7.5,1.6L1.6,6V14.4z" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Home.js